import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { ShoppingBag, Menu, X } from "lucide-react";
import { useCart } from "../context/CartContext";
import { useCategories } from "../context/StoreDataContext";

export default function Header() {
    const { count } = useCart();
    const { categories } = useCategories();
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();

    const baseLinks = [
        { to: "/", label: "Inicio" },
        { to: "/catalogo", label: "Catálogo" },
    ];
    const catLinks = categories.slice(0, 4).map((c) => ({
        to: `/catalogo?cat=${c.slug}`,
        label: c.name,
    }));

    return (
        <header
            className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-ivory/70 border-b border-border-soft/50"
            data-testid="site-header"
        >
            <div className="px-6 md:px-12 lg:px-20 py-4 flex items-center justify-between">
                <Link
                    to="/"
                    className="flex items-baseline gap-2 group"
                    data-testid="logo-link"
                >
                    <span className="font-serif italic text-2xl md:text-3xl text-charcoal tracking-tight">
                        Luz de
                    </span>
                    <span className="font-serif text-2xl md:text-3xl text-rose tracking-tight">
                        Angely
                    </span>
                </Link>

                <nav className="hidden lg:flex items-center gap-8" data-testid="primary-nav">
                    {baseLinks.map((l) => (
                        <NavLink
                            key={l.to}
                            to={l.to}
                            className={({ isActive }) =>
                                `text-sm tracking-wider uppercase transition-colors ${
                                    isActive ? "text-rose" : "text-charcoal hover:text-rose"
                                }`
                            }
                        >
                            {l.label}
                        </NavLink>
                    ))}
                    {catLinks.map((l) => (
                        <Link
                            key={l.to}
                            to={l.to}
                            className="text-sm tracking-wider uppercase text-taupe hover:text-rose transition-colors"
                        >
                            {l.label}
                        </Link>
                    ))}
                </nav>

                <div className="flex items-center gap-4">
                    <button
                        onClick={() => navigate("/carrito")}
                        className="relative p-2 hover:text-rose transition-colors"
                        data-testid="cart-icon-btn"
                        aria-label="Carrito"
                    >
                        <ShoppingBag strokeWidth={1.5} className="w-5 h-5" />
                        {count > 0 && (
                            <span
                                data-testid="cart-count-badge"
                                className="absolute -top-0.5 -right-0.5 bg-rose text-white text-[10px] rounded-full w-4 h-4 flex items-center justify-center font-medium"
                            >
                                {count}
                            </span>
                        )}
                    </button>
                    <button
                        onClick={() => setOpen((o) => !o)}
                        className="lg:hidden p-2"
                        data-testid="mobile-menu-toggle"
                        aria-label="Menú"
                    >
                        {open ? <X strokeWidth={1.5} /> : <Menu strokeWidth={1.5} />}
                    </button>
                </div>
            </div>

            {open && (
                <div className="lg:hidden border-t border-border-soft/50 bg-ivory/95 backdrop-blur-xl">
                    <nav className="px-6 py-6 flex flex-col gap-4" data-testid="mobile-nav">
                        {[...baseLinks, ...catLinks].map((l) => (
                            <Link
                                key={l.to}
                                to={l.to}
                                onClick={() => setOpen(false)}
                                className="text-sm tracking-wider uppercase text-charcoal hover:text-rose"
                            >
                                {l.label}
                            </Link>
                        ))}
                    </nav>
                </div>
            )}
        </header>
    );
}
